// extracted by mini-css-extract-plugin
export default {"logoCarouselScroll":"PartnerLogoStrip_logoCarouselScroll__FHm13","logoItem":"PartnerLogoStrip_logoItem__sxBe8","logoImg":"PartnerLogoStrip_logoImg__HUqI8"};